import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";

const api = new APIClient();

const RESOURCE = "/expenses";

export type ExpenseCostType = "fixed" | "variable";

export type ExpenseCategory =
  | "rent"
  | "utilities"
  | "supplies"
  | "payroll"
  | "marketing"
  | "maintenance"
  | "insurance"
  | "taxes"
  | "other";

export const EXPENSE_COST_TYPES: ExpenseCostType[] = ["fixed", "variable"];

export const EXPENSE_CATEGORIES: ExpenseCategory[] = [
  "rent",
  "utilities",
  "supplies",
  "payroll",
  "marketing",
  "maintenance",
  "insurance",
  "taxes",
  "other",
];

export interface ExpenseUnitRef {
  id: number;
  name: string;
}

export interface ExpenseUserRef {
  id: number;
  name: string;
}

export interface Expense {
  id: number;
  tenant_id: number;
  unit_id: number;
  cost_type: ExpenseCostType;
  category: ExpenseCategory;
  description: string;
  amount_cents: number;
  incurred_at: string;
  notes: string | null;
  created_by_user_id: number | null;
  created_at: string;
  updated_at: string;
  unit?: ExpenseUnitRef;
  created_by?: ExpenseUserRef;
}

export interface CreateExpensePayload {
  unit_id: number;
  cost_type: ExpenseCostType;
  category: ExpenseCategory;
  description: string;
  amount_cents: number;
  incurred_at: string;
  notes?: string | null;
}

export type UpdateExpensePayload = Partial<CreateExpensePayload>;

export interface ExpenseListParams extends PaginationParams {
  unit_id?: number;
  cost_type?: ExpenseCostType;
  category?: ExpenseCategory;
  from?: string;
  to?: string;
  search?: string;
}

export const getExpenses = (
  params?: ExpenseListParams
): Promise<PaginatedApiResponse<Expense>> =>
  api.get<PaginatedApiResponse<Expense>>(RESOURCE, params);

export const getExpense = (id: number): Promise<ApiResponse<Expense>> =>
  api.get<ApiResponse<Expense>>(`${RESOURCE}/${id}`);

export const createExpense = (
  payload: CreateExpensePayload
): Promise<ApiResponse<Expense>> =>
  api.create<ApiResponse<Expense>>(RESOURCE, payload);

export const updateExpense = (
  id: number,
  payload: UpdateExpensePayload
): Promise<ApiResponse<Expense>> =>
  api.update<ApiResponse<Expense>>(`${RESOURCE}/${id}`, payload);

export const deleteExpense = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);
